import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({ icon: Icon = Inbox, title, description, action }) => (
    <div className="card p-10 sm:p-12 text-center relative overflow-hidden">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-50 to-primary-100/60 text-primary-700 ring-1 ring-primary-700/10 shadow-xs flex items-center justify-center">
            <Icon className="w-7 h-7 stroke-[1.75]" />
        </div>
        <h3 className="mt-4 text-base font-semibold text-neutral-900 tracking-tight">{title}</h3>
        {description && <p className="mt-1.5 text-sm text-neutral-500 max-w-sm mx-auto leading-relaxed">{description}</p>}
        {action && <div className="mt-6 flex justify-center">{action}</div>}
    </div>
);

export default EmptyState;
